import React, { CSSProperties } from 'react';
import { Avatar } from 'glints-aries/es/@next';
import { Blue, Neutral } from 'glints-aries/es/@next/utilities/colors';
import styled from 'styled-components';

import { ProfilePicture } from './GlintsPicture';

const DEFAULT_INITIALS_RATIO = 18 / 60;
const MIN_INITIALS_SIZE = 14;
const MAX_INITIALS_SIZE = 32;

const getInitialsFontSize = (avatarSize: number) =>
  Math.min(
    MAX_INITIALS_SIZE,
    Math.max(MIN_INITIALS_SIZE, Math.round(avatarSize * DEFAULT_INITIALS_RATIO))
  );

const InitialsAvatar = styled(Avatar)<{ $initialsFontSize: number }>`
  background-color: ${Neutral.B95};

  > span {
    color: ${Blue.S99};
    font-size: ${props => props.$initialsFontSize}px;
  }
`;

type Props = {
  alt?: string;
  avatarSize: number;
  className?: string;
  name: string;
  profilePic?: string | null;
  style?: CSSProperties;
  userId: string;
};

export default function EmployerUserAvatar({
  alt,
  avatarSize,
  className,
  name,
  profilePic,
  style,
  userId,
}: Props) {
  const dimensions = { width: avatarSize, height: avatarSize, ...style };

  if (profilePic) {
    return (
      <ProfilePicture
        alt={alt}
        className={className}
        profilePic={profilePic}
        style={dimensions}
        userId={userId}
      />
    );
  }

  const initial = (Array.from(name.trim())[0] || '#').toUpperCase();

  return (
    <InitialsAvatar
      $initialsFontSize={getInitialsFontSize(avatarSize)}
      aria-label={alt}
      className={className}
      initials={initial}
      style={dimensions}
      variant="supplementary"
    />
  );
}
